import React, { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api/http";
import "../../styles/about/Servicii.css";

const ServiceComponent = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      setLoading(true);
      setErrMsg("");

      try {
        const res = await api.get("/about/servicii");
        const data = res.data;

        const items = Array.isArray(data?.results)
          ? data.results
          : Array.isArray(data)
          ? data
          : [];

        if (!mounted) return;
        setServices(items);
      } catch (e) {
        if (!mounted) return;
        setErrMsg(
          e?.response?.data?.detail ||
            e?.message ||
            "Eroare la încărcare."
        );
        setServices([]);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    };

    run();
    return () => {
      mounted = false;
    };
  }, []);

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3200,
      arrows: true,
      adaptiveHeight: false, // 🔴 IMPORTANT
      responsive: [
        { breakpoint: 1100, settings: { slidesToShow: 2 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
      ],
    }),
    []
  );

  return (
    <section className="srSvc_page">
      <div className="srSvc_wrap">
        <header className="srSvc_header">
          <h2 className="srSvc_title">Serviciile Noastre</h2>
        </header>

        <div className="srSvc_card">
          {loading ? (
            <p className="srSvc_muted">Se încarcă...</p>
          ) : errMsg ? (
            <p className="srSvc_error">{errMsg}</p>
          ) : (
            <Slider {...settings} className="srSvc_slider">
              {services.map((s, idx) => (
                <div className="srSvc_slide" key={s?.id ?? idx}>
                  <div className="srSvc_item">
                    <p className="srSvc_itemText">
                      {s?.serviciu ?? ""}
                    </p>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServiceComponent;